import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    authChangedEvent,
    clearAuthTokens,
    getStoredAccessToken,
    getValidAccessToken,
} from "../api/authSession";

export function useAuth() {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        let mounted = true;

        const validateSession = async () => {
            try {
                const token = await getValidAccessToken();
                if (mounted) setIsAuthenticated(!!token);
            } catch {
                // Keep the current session during a temporary network failure.
                if (mounted) setIsAuthenticated(!!getStoredAccessToken());
            } finally {
                if (mounted) setIsLoading(false);
            }
        };

        void validateSession();

        const handleStorageChange = () => {
            setIsAuthenticated(!!getStoredAccessToken());
        };

        window.addEventListener("storage", handleStorageChange);
        window.addEventListener(authChangedEvent, handleStorageChange);
        window.addEventListener("focus", validateSession);
        const validationInterval = window.setInterval(validateSession, 60_000);

        return () => {
            mounted = false;
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener(authChangedEvent, handleStorageChange);
            window.removeEventListener("focus", validateSession);
            window.clearInterval(validationInterval);
        };
    }, []);

    const logout = () => {
        clearAuthTokens();
        setIsAuthenticated(false);
        navigate("/login");
    };

    return { isAuthenticated, isLoading, logout };
}
